import request from '@/utils/request'

let LoginApi = {
  /*密码登录*/
  passwordLogin(data, errorback) {
    return request._postBody('/user/userOpen/passwordLogin', data, errorback);
  },
  /*验证码登录*/
  codeLogin(data, errorback) {
    return request._postBody('/user/userOpen/smsLogin', data, errorback);
  },
  // 验证码
  sendCode(data, errorback) {
    return request._postBody('/user/userOpen/sendCode', data, errorback);
  },
  // 重置密码
  resetpasswordSub(data, errorback) {
    return request._postBody('/user/userOpen/resetpassword', data, errorback);
  },
  // 会员认证
  registerSub(data, errorback) {
    return request._postBody('/user/userOpen/authentication', data, errorback);
  },
  // 个人信息
  userInfo(data, errorback) {
    return request._post('/user/index/index', data, errorback);
  },
}
export default LoginApi;


// WEBPACK FOOTER //
// ./src/api/loginApi.js